import { useEffect, useState } from 'react';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

const allowedExtensions = ["csv"];

export default function SelectFormName(props) {
    const { selectedFormInfo } = props;
    return (
        <div className='header-form-name'>
            フォーマット:  {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedFormInfo.name)}
        </div>
    );
}